function OffHoursSchedule() {
    "use strict";
    var lDate = new Date(),
        lStartDate = new Date(),
        lEndDate = new Date();

    this.__type = 'OffHoursSchedule:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    lEndDate.addHours(0 - lDate.getHours() + 3);
    lEndDate.addMinutes(0 - lDate.getMinutes());
    this.EndTime = lEndDate;
    this.IsActive = true;
    this.IsFriday = false;
    this.IsMonday = false;
    this.IsNoSchedule = false;
    this.IsRecurring = true;
    this.IsSaturday = false;
    this.IsSunday = false;
    this.IsThursday = false;
    this.IsTuesday = false;
    this.IsWednesday = false;
    this.Name = '';
    lStartDate.addHours(0 - lDate.getHours());
    lStartDate.addMinutes(0 - lDate.getMinutes());
    this.StartTime = lStartDate;

    this.AgentId = -1;
    this.TransactionId = moment().format("YYYYMMDDHHmmss");
}
if (typeof exports !== 'undefined') {
    module.exports = OffHoursSchedule;
}